module.exports = __webpack_public_path__ + "img/68ne.6c27effd.svg";